<template>
  <div id="AlertScreen" class="alert-screen-total" v-if="showAlertScreen">
    <div class="alert-screen-box">
      <div class="alert-screen-text">
        <p class="alert--title">{{alertTitle}}</p>
        <p v-html="alertText"></p>
      </div>
      <div class="alert-screen-buttons">
        <button
          class="btn btn-secundario"
          @click="$emit('returnAlertScreen', 0)"
          v-if="!hideCancel"
        >{{cancelText}}</button>
        <button class="btn btn-primario" @click="$emit('returnAlertScreen', 1)">{{confirmText}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertScreen",
  props: {
    showAlertScreen: {
      type: Boolean,
      required: true,
      default: false
    },
    alertTitle: {
      type: String,
      required: false,
      default: "Atenção!"
    },
    alertText: {
      type: String | Array,
      required: false,
      default: "Deseja realmente realizar esta ação?"
    },
    confirmText: {
      type: String,
      required: false,
      default: "Sim"
    },
    cancelText: {
      type: String,
      required: false,
      default: "Cancelar"
    },
    hideCancel: {
      type: Boolean,
      required: false,
      default: false
    }
  },
};
</script>

<style scoped>
.alert-screen-total {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 1100;
}
.alert-screen-box {
  max-width: 400px;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
}
.alert-screen-total .alert-screen-box button {
  min-width: 90px;
  margin: 0 5px;
}
.alert--title {
  font-weight: 700;
  font-size: 28px;
}
.btn-secundario {
  background-color: #777;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/AlertScreen.vue